import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateReturnLoss from '@/modules/promotion/api/hooks/useMutateUpdateReturnLoss'
import { ReturnLossQueryKeys } from '@/modules/promotion/keys'
import { GetReturnLossResponseData } from '@/modules/promotion/type'
import { useQueryClient } from '@tanstack/react-query'

interface IsActiveReturnLossProps {
	row: GetReturnLossResponseData
}

export function IsActiveReturnLoss({ row }: IsActiveReturnLossProps) {
	const { mutateAsync: updateReturnLoss } = useMutationUpdateReturnLoss()
	const queryClient = useQueryClient()

	const handleMutate = async (value: boolean) => {
		await updateReturnLoss(
			{
				id: row.id,
				payload: {
					isActive: value,
				},
			},
			{
				onSuccess: () => {
					queryClient.invalidateQueries({
						queryKey: [ReturnLossQueryKeys.GetReturnLossList],
					})
				},
			},
		)
	}

	return <SetIsActive defaultChecked={row.isActive} onMutate={handleMutate} />
}
